<template>
    <v-app id="parent-approval">
        <!-- Overlay -->
        <v-overlay absolute color="#fff" opacity="1" :value="loader" z-index="999">
            <v-img class="mb-5" src="../../assets/backgrounds/kings_logo.jpg" max-width="200px"></v-img>
            <v-progress-circular :color="kingsGreen" indeterminate size="50"></v-progress-circular>
        </v-overlay>

        <!-- Toolbar -->
        <parent-approval-toolbar></parent-approval-toolbar>

        <!-- Main -->
        <v-content>
            <v-container class="fill-height pt-12 pb-12" fluid>
                <parent-approval-main :id="id" :status="status" :submit="submit" @submitApproval="submitApproval">
                </parent-approval-main>
            </v-container>
        </v-content>

        <!-- Footer -->
        <parent-approval-footer></parent-approval-footer>
    </v-app>
</template>

<script>
import ParentApprovalFooter from '../../components/Public/ParentApproval/Footer';
import ParentApprovalMain from '../../components/Public/ParentApproval/Main';
import ParentApprovalToolbar from '../../components/Public/ParentApproval/Toolbar';

export default {
    name: 'parent-approval',
    components: {
        ParentApprovalFooter,
        ParentApprovalMain,
        ParentApprovalToolbar
    },
    props: ['id'],
    data() {
        return {
            loader: true,
            status: '',
            submit: false
        }
    },
    methods: {
        submitApproval(code) {
            if (code) {
                const that = this;
                const formData = new FormData();
                let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?parentApproval`;

                // Parse array into string
                formData.append('code', code);
                formData.append('mode', 'parentApproval');

                // Submit loader
                this.submit = true;

                // Post request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Return JSON response
                        return response.json();
                    })
                    .then(function (json) {
                        // Approved
                        if (json.status.match(/^approved/gi)) {
                            that.status = 'approved';
                        } else if (json.status.match(/^previously approved/i)) {
                            that.status = 'processed';
                        } else {
                            that.status = 'invalid';
                        }

                        that.submit = false;
                        that.loader = false;
                    })
                    .catch(function () {
                        that.status = 'error';
                        that.submit = false;
                        that.loader = false;
                    });
            } else {
                this.loader = false;
            }
        }
    },
    computed: {
        kingsGreen() {
            return '#004236';
        },
    },
    created() {
        this.submitApproval(this.id);
    }
}
</script>

<style>
.v-overlay__content {
    text-align: center;
}
</style>